export default "__VITE_ASSET__43e41388__"